import {RequireFeature} from '@services/helper/permission.helper'
import {ComponentType, createElement, lazy} from 'react'

/**
 * Wrap a lazily-loaded page in a RequireFeature guard so a direct URL visit is
 * redirected to the dashboard when the user lacks the feature. Kept JSX-free so
 * route files stay `.ts`. `anyOf` = feature URL(s) that grant access.
 */
export const guard = (
  importer: () => Promise<{default: ComponentType<any>}>,
  anyOf: string[]
) => {
  const Comp = lazy(importer)
  return () => createElement(RequireFeature, {anyOf, children: createElement(Comp)})
}
